import React, { useEffect, useState } from "react";
import { ResourcesWrapper } from "./ThirdPartyStyles";
import { SendIcon } from "./assets/svgExport";
import AuditCard from "./assets/AuditCard";
import styled from "styled-components";
import { default as useApiHook } from "./assets/api/UseAxios";

// ✅ Skeleton Component
const NotesSkeleton = () => {
  return (
    <div style={{ padding: "12px" }}>
      {[...Array(6)].map((_, i) => (
        <div
          key={i}
          style={{
            background: "#EAECF0",
            height: "48px",
            borderRadius: "6px",
            marginBottom: "8px",
            animation: "pulse 1.4s infinite ease-in-out",
          }}
        ></div>
      ))}
    </div>
  );
};

const Notes = (fetchedData: any) => {
  const [note, setNote] = useState("");

  const details = fetchedData?.fetchedData?.data?.[0];

  const handleSubmit = () => {
    console.log("hey");
  };

  const {
    fetchData: fetchDetails,
    loading,
    data: fetchedDetails,
  } = useApiHook<{ data: any }>({
    endpoint: `/audit_logs/Vehicle_Maintenance_AuditLogs_by_workshop/?url=/audit_log/vehicle_defect/&module_object_id=${details?.id}&page=1&per_page=50`,
    method: "GET",
  });

  useEffect(() => {
    if (details?.id) {
      fetchDetails();
    }
  }, [details?.id]);

  return (
    <Wrapper>
      <div className="Maincontainer">
        <div className="cardHeader">
          <div className="headerText">Notes</div>
        </div>

        <div className="subContainer">
          <div
            style={{
              height: "375px",
              overflowY: "auto",
            }}
          >
            {loading ? <NotesSkeleton /> : <AuditCard data={fetchedDetails?.data} />}
          </div>

          <div className="inputContainer-3">
            <textarea className="textBox" placeholder="Add New Note" value={note} onChange={(e) => setNote(e.target.value)} />
            <div className="sendBox" onClick={handleSubmit} style={{ cursor: "not-allowed", opacity: "0.5" }}>
              <SendIcon />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Notes;

export const Wrapper = styled(ResourcesWrapper)`
  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.45;
    }
    100% {
      opacity: 1;
    }
  }

  h1 {
    color: var(--Grey-01, #090b0e);
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .headerText {
    color: #090b0e;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
  }

  .cardHeader {
    background: none !important;
    border-radius: 10px 10px 0px 0px;
  }

  .headerSlider {
    background: #eaecf0;
  }

  .MainContainer {
    height: 430px !important;
  }
`;
